export default "__VITE_PUBLIC_ASSET__bb15c4b6__"